import { useIntl } from "react-intl";

import {
    ProductNavBar,
    ProductNavLink
} from "@/components/wpl/product-navbar/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const ConfluenceSoftwareNav = () => {
    const intl = useIntl();

    const dataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-event": "clicked"
    };
    const features = {
        ...dataEventProps,
        "data-track-event": "ConfluenceSoftwareNav.features",
        "data-label": "confluenceSoftwareNav.features"
    };

    const resources = {
        ...dataEventProps,
        "data-track-event": "ConfluenceSoftwareNav.resources",
        "data-label": "confluenceSoftwareNav.resources"
    };

    const templates = {
        ...dataEventProps,
        "data-track-event": "ConfluenceSoftwareNav.templates",
        "data-label": "confluenceSoftwareNav.templates"
    };

    const pricing = {
        ...dataEventProps,
        "data-track-event": "ConfluenceSoftwareNav.pricing",
        "data-label": "confluenceSoftwareNav.pricing"
    };

    const enterprise = {
        ...dataEventProps,
        "data-track-event": "ConfluenceSoftwareNav.enterprise",
        "data-label": "confluenceSoftwareNav.enterprise"
    };

    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software/confluence")}
            productName="confluence"
            freeHref={useLocalizedHref("/software/confluence/free")}
            ariaLabel={intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.logo-label",
                defaultMessage: "Confluence logo"
            })}
            dataProductKey="confluence"
            logoLinkWrapperWidth="189px"
        >
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.features",
                    defaultMessage: "Features"
                })}
                href={useLocalizedHref("/software/confluence/features")}
                dataEventProps={features}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                    defaultMessage: "Resources"
                })}
                href={useLocalizedHref("/software/confluence/resources")}
                dataEventProps={resources}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.templates",
                    defaultMessage: "Templates"
                })}
                href={useLocalizedHref("/software/confluence/templates")}
                dataEventProps={templates}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                    defaultMessage: "Pricing"
                })}
                href={useLocalizedHref("/software/confluence/pricing")}
                dataEventProps={pricing}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                    defaultMessage: "Enterprise"
                })}
                href={useLocalizedHref("/software/confluence/enterprise")}
                dataEventProps={enterprise}
            />
        </ProductNavBar>
    );
};

ConfluenceSoftwareNav.displayName = "ConfluenceSoftwareNav";

export default ConfluenceSoftwareNav;
